import { useEffect, useState } from "react"

// An image counts as "wide" (e.g. a business logo) when it is clearly wider than tall.
// Squares and ordinary photos stay below this and keep the default fill-the-circle look.
export const WIDE_IMAGE_ASPECT_RATIO = 1.5

export function useIsWideImage(src) {
  const [isWide, setIsWide] = useState(false)

  useEffect(() => {
    setIsWide(false)
    if (!src || typeof src !== "string") return undefined

    let isCancelled = false
    const img = new window.Image()
    img.onload = () => {
      if (isCancelled || !img.naturalHeight) return
      setIsWide(img.naturalWidth / img.naturalHeight > WIDE_IMAGE_ASPECT_RATIO)
    }
    img.src = src
    return () => {
      isCancelled = true
    }
  }, [src])

  return isWide
}
